module.exports = __webpack_public_path__ + "std/img/login-gold.c9b48cb.webp";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/login-gold.webp
// module id = st2n
// module chunks = 0